// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"Modal_modal-wrapper__gj0Ye","modal-content":"Modal_modal-content__qxRhZ","modal-close":"Modal_modal-close__371JP"};